"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, useMemo } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppConfigProvider } from "@/lib/config";
import type { AppConfig } from "@/lib/config-server";
import type { PostHogConfig } from "posthog-js";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}
export function Providers(t0) {
  const $ = _c(18);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 300000,
          retry: false
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== config.posthogHost) {
    t2 = {
      api_host: config.posthogHost,
      capture_pageview: "history_change",
      autocapture: true
    };
    $[1] = config.posthogHost;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const posthogOptions = t2;
  let t3;
  let t4;
  if ($[3] !== config.posthogKey || $[4] !== posthogOptions) {
    t3 = () => {
      if (!config.posthogKey) {
        return;
      }
      const key = config.posthogKey;
      const init = () => {
        posthog.init(key, posthogOptions);
      };
      if (typeof requestIdleCallback !== "undefined") {
        const id = requestIdleCallback(init);
        return () => cancelIdleCallback(id);
      }
      const timer = setTimeout(init, 1000);
      return () => clearTimeout(timer);
    };
    t4 = [config.posthogKey, posthogOptions];
    $[3] = config.posthogKey;
    $[4] = posthogOptions;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== children) {
    t5 = <PostHogProvider client={posthog}>{children}</PostHogProvider>;
    $[7] = children;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = process.env.NODE_ENV === "development" && <ReactQueryDevtools buttonPosition="top-right" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <QueryClientProvider client={queryClient}>{t5}{t6}</QueryClientProvider>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Toaster />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t7}{t8}</ThemeProvider>;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== config || $[16] !== t9) {
    t10 = <AppConfigProvider config={config}>{t9}</AppConfigProvider>;
    $[15] = config;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}